import {
  COMMISSIONS_CREATE_NEW_MONTH_BEGIN,
  COMMISSIONS_CREATE_NEW_MONTH_SUCCESS,
  COMMISSIONS_CREATE_NEW_MONTH_FAILURE,
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_CREATE_NEW_MONTH_BEGIN:
      return {
        ...state,
        createNewCommissionMonthPending: true
      }
    case COMMISSIONS_CREATE_NEW_MONTH_SUCCESS:
      return {
        ...state,
        createNewCommissionMonthPending: false,
        createNewCommissionMonthSuccess: true,
        createNewCommissionMonthError: null
      }
    case COMMISSIONS_CREATE_NEW_MONTH_FAILURE:
      return {
        ...state,
        createNewCommissionMonthPending: false,
        createNewCommissionMonthError: action.data
      }
    default:
      return state
  }
}
